import { render, staticRenderFns } from "./CodingSchemaShow.vue?vue&type=template&id=33cf40a5&"
import script from "./CodingSchemaShow.vue?vue&type=script&lang=js&"
export * from "./CodingSchemaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports